import type { RootState } from '@shared/stores/rootTypes';

const originUrlSelector = (state: RootState) => state.origin.originUrl;

export { originUrlSelector };
